import $ from 'jquery';
import 'slick-carousel';

$('.reviews-collapse').each(function () {
  const $group = $(this);
  $group.find('.collapse-nav').on('click', function (e) {
    e.preventDefault();

    const wasActive = $(this).hasClass('activated');
    const selfCollapse = $(this).data('self-collapse');

    if (!wasActive) {
      $group.toggleClass('activated');
    } else {
      if (selfCollapse) {
        $group.toggleClass('activated');
      }
    }
  });
});

$('.reviews-collapse .reviews-google').on('click', function (e) {
  e.stopPropagation();
});
